import React, { useEffect } from 'react';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';
import CategurysList from './Categurys-list/CategurysList';

const MyCategurys = (props) => {

    useEffect(() => {

    }, [])

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
                    <Sidenavigation1 />
                    <main className="body-content">
                        <Topnavigation />
                        <CategurysList />
                    </main>
                    {/* <Quickbar /> */}
               

            </TheMasterContextProvider>
        </div>
    );
}

export default MyCategurys;